var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15 3.75.4472-.89443c-.2815-.14076-.6129-.14076-.8944 0zm10 5h1c0-.37877-.214-.72504-.5528-.89443zm-20 0-.44721-.89443c-.33879.16939-.55279.51566-.55279.89443zm20 12.5.4472.8944c.3388-.1694.5528-.5156.5528-.8944zm-10 5-.4472.8944c.2815.1408.6129.1408.8944 0zm-10-5h-1c0 .3788.214.725.55279.8944zm9.5528-16.60557 10 5 .8944-1.78886-10-5zm10 3.21114-10 5.00003.8944 1.7888 10-4.99997zm-9.1056 5.00003-9.99999-5.00003-.89442 1.78886 10.00001 4.99997zm-9.99999-3.21117 9.99999-5-.8944-1.78886-10.00001 5zm19.10559 10.71117-10 5 .8944 1.7888 10-5zm-9.1056 5-9.99999-5-.89442 1.7888 10.00001 5zm-9.4472-4.1056v-12.5h-2v12.5zm20 0v-12.5h-2v12.5zm-12-7.5v12.5h2v-12.5z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCube);
export default __webpack_public_path__ + "static/media/icon_cube.3cd9a4054e3af80b325b8c827e445ac1.svg";
export { ForwardRef as ReactComponent };